// extracted by mini-css-extract-plugin
module.exports = {"lazy":"lazy-image_lazy__aiuVh","lazyLoaded":"lazy-image_lazyLoaded__9eHau"};